import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api, formatError } from "../lib/api";

export default function Unsubscribe() {
  const [params] = useSearchParams();
  const [state, setState] = useState({ status: "loading" });
  useEffect(() => {
    const token = params.get("token");
    if (!token) return setState({ status: "error", msg: "This unsubscribe link is missing its token." });
    api.post("/follows/unsubscribe", { token, slug: params.get("deity") || null })
      .then((r) => setState({ status: "ok", ...r.data }))
      .catch((e) => setState({ status: "error", msg: formatError(e) }));
  }, [params]);

  return (
    <div data-testid="unsubscribe-page" className="max-w-xl mx-auto px-4 py-24 text-center">
      <div className="font-devanagari text-6xl text-[#D4AF37]">ॐ</div>
      {state.status === "loading" && <p className="mt-6 text-[#63534E]">Updating your preferences…</p>}
      {state.status === "ok" && (
        <>
          <h1 data-testid="unsubscribe-success" className="font-serif text-4xl text-[#4A0E17] mt-4">You've been unsubscribed</h1>
          <p className="text-[#63534E] mt-4">{state.email} will no longer get deity festival alerts{state.removed ? ` (${state.removed} follow${state.removed > 1 ? "s" : ""} removed)` : ""}.</p>
        </>
      )}
      {state.status === "error" && <p data-testid="unsubscribe-error" className="mt-6 text-red-700">{state.msg}</p>}
      <Link to="/deities" className="btn-ghost-gold mt-8 inline-flex">Back to Gods & Goddesses</Link>
    </div>
  );
}
